const months_ab=['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez'];
const months=[ 'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
const weeks = ['Dom','Seg','Ter','Qua','Qui','Sex','Sáb']

export function getTitleByDay(v){
  if(v.length === 5){
    return `${v[v.length-1]}, ${v[1]} de ${months_ab[parseInt(v[2])-1]}`;
  }
  return `${weeks[parseInt(v[0])]}, ${v[1]} de ${months_ab[parseInt(v[2])-1]}`;
}

export function getTitleByMonth(v){
  return months[parseInt(v[2])-1]+" "+v[3];
}